import {ValidatorFn} from '@angular/forms';

export abstract class CommonValidator {
	getValidator(context: any): ValidatorFn {
		// return validation function
		throw new Error('CommonValidator#getValidator Method needs to be reloaded');
		return null as ValidatorFn;
	}
}
